(function (angular) {
    'use strict';

    angular.module('inboundRules')
        /**
         *
         */
        .controller('updatePropertyModalCtrl',
            ['$scope', '$uibModalInstance', 'settings', 'inboundRule',
                function ($scope, $uibModalInstance, settings, inboundRule) {

                    $scope.settings = angular.copy(settings);
                    $scope.inboundRule = angular.copy(inboundRule);
                    if (!$scope.inboundRule.actionData) {
                        $scope.inboundRule.actionData = {};
                    }
                    if (!$scope.inboundRule.actionData.profileUpdate) {
                        $scope.inboundRule.actionData.profileUpdate = [];
                    }
                    $scope.inboundRule.actionData.profileUpdate.push({});


                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $scope.close = function () {
                        if (!$scope.inboundRule.actionData.profileUpdate[0].key || !$scope.inboundRule.actionData.profileUpdate[0].key.length) {
                            $scope.inboundRule.actionData.profileUpdate = [];
                        }
                        $uibModalInstance.close($scope.inboundRule.actionData.profileUpdate[0]);
                    };

                }]);


})(window.angular);